export default __webpack_public_path__ + "static/media/granville21.3be420e0.jpg";